import { createFileRoute, stripSearchParams } from '@tanstack/react-router'

import { TeamListPage } from '@/features/org/components/team-list-page'
import { TEAMS_SEARCH_DEFAULTS, teamsSearchSchema } from '@/features/org/search-schema'

/**
 * /teams —— 团队管理(组织维护视角,缩进树)。
 *
 * 关键词与排序进 search params(A4:等于默认值的不回写 URL)。
 * **没有分页**:树要成型必须拿到全集,否则子团队会被切到下一页变成孤儿行 ——
 * 理由与取值面见 features/org/search-schema.ts 的 `TEAM_TREE_PAGE_SIZE`。
 */
export const Route = createFileRoute('/_authed/teams/')({
  validateSearch: teamsSearchSchema,
  search: {
    middlewares: [stripSearchParams(TEAMS_SEARCH_DEFAULTS)],
  },
  component: TeamListPage,
})
